import { render } from "./HomeM.vue?vue&type=template&id=f8777da4&scoped=true"
import script from "./HomeM.vue?vue&type=script&lang=js"
export * from "./HomeM.vue?vue&type=script&lang=js"

import "./HomeM.vue?vue&type=style&index=0&id=f8777da4&lang=scss&scoped=true"

import exportComponent from "G:\\官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8777da4"]])

export default __exports__